export default __webpack_public_path__ + "static/media/galaxis_swirl_only_orange.78a25290.svg";